import gql from 'graphql-tag';
import { closeEditBookingTripStatusModal} from '../modalActions';
import { toastr } from 'react-redux-toastr';

const mutation = gql`
            mutation UpdateStatusBooking($bookingId: Int!) {
                UpdateStatusBooking(bookingId: $bookingId) {
                status,
                errorMessage
            }
            }
            `;
export default function updateBookingTripStatus(bookingIdData) {
    return async (dispatch, getState, {client}) => {
        try {
            const { data } = await client.mutate({
                            mutation: mutation,
                            variables:{
                                bookingId:parseInt(bookingIdData)
                            },
                        });


            if (data.UpdateStatusBooking.status === 200) {
                toastr.success('Success', `Trip status booking has been updated successfully.`);
            } else {
                toastr.error( "Error!","Oops! something went wrong. Please try again.");
            }
            dispatch(closeEditBookingTripStatusModal())
            return true;
        }
        catch (error) {
            console.log(error)
            toastr.error("Error!", "Oops! something went wrong. Please try again. " + error);
            return false;
        }
    };
}